export default __webpack_public_path__ + "static/media/undraw_page_not_found_su7k.bce7cd38.svg";